import React, { PropTypes as p } from 'react'
import Measure from 'react-measure'
import round from 'lodash/round'
import omit from 'lodash/omit'

const PinCushion = React.createClass({
  propTypes: {
    children: p.node,
    onPinPlace: p.func
  },

  handleClick (event, measurements) {
    this.props.onPinPlace &&
      this.props.onPinPlace(this.getIntendedPinPosition(event, measurements))
  },

  getIntendedPinPosition (event, measurements) {
    const container = document.querySelector('.content-container')
    const scroll = container.scrollTop

    return {
      x: round((event.clientX - measurements.left) / measurements.width, 4),
      y: round((event.clientY + scroll - measurements.top) / measurements.height, 4)
    }
  },

  render () {
    const {
      children,
      ...rest
    } = this.props

    return (
      <Measure whitelist={['left', 'top', 'width', 'height']}>
        {measurements =>
          <div
            className='pin-cushion'
            onClick={(event) => this.handleClick(event, measurements)}
            {...omit(rest, ['onPinPlace'])}
          >
            {children}
          </div>
        }
      </Measure>
    )
  }
})

export default PinCushion



// WEBPACK FOOTER //
// ./src/components/pins/pin-cushion.js